/** Validates stored import payloads at API and web boundaries without rejecting synthetic columns. */
import { MetadataImportValidationTransportData } from './metadata.validation.data';

/** Used by payload validation and CSV decoding; empty paths belong to synthetic import columns. */
export function isMetadataImportHeaders(value: unknown): value is Array<string | null | undefined> {

    // The Include/Exclude column has no field path; JSON stores its undefined array entry as null.
    return Array.isArray(value) && value.every(header => header == null || typeof header === 'string');
}

/** Used by the import worker and debug endpoint before deserialization; routing is checked separately. */
export function isMetadataImportPayload(value: unknown): value is MetadataImportValidationTransportData {

    if (!value || typeof value !== 'object') {
        return false;
    }
    if (!('name' in value) || typeof value.name !== 'string') {
        return false;
    }
    if (!('module' in value) || typeof value.module !== 'string') {
        return false;
    }
    if (!('entity' in value) || typeof value.entity !== 'string') {
        return false;
    }
    if (!('headers' in value) || !isMetadataImportHeaders(value.headers)) {
        return false;
    }
    if (!('rows' in value) || !Array.isArray(value.rows) || !value.rows.every(row => Array.isArray(row))) {
        return false;
    }
    return !('config' in value) || value.config === undefined || (!!value.config && typeof value.config === 'object');
}
